import deBlogPosts from "./blogPosts.json";
import deBghUrteile from "./bghUrteile.json";
import deCalculator from "./calculator.json";
import deCommon from "./common.json";
import deDialogs from "./dialogs.json";
import deExpertise from "./expertise.json";
import { deExpertiseCity } from "./expertiseCityCatalog";
import deExpertiseSolutions from "./expertiseSolutions.json";
import deFaqs from "./faqs.json";
import deFooter from "./footer.json";
import deHome from "./home.json";
import deJudgmentsLanding from "./judgmentsLanding.json";
import deLandingpages from "./landingpages.json";
import deNav from "./nav.json";
import deReferences from "./references.json";
import deSolvingTax from "./solvingTax.json";
import deTeam from "./team.json";

/** German catalog — source of truth for shape (`Messages` in `buildCatalog`). */
export const deCatalog = {
  nav: deNav,
  footer: deFooter,
  home: deHome,
  common: deCommon,
  dialogs: deDialogs,
  expertise: deExpertise,
  expertiseCity: deExpertiseCity,
  blogPosts: deBlogPosts,
  landingpages: deLandingpages,
  team: deTeam,
  references: deReferences,
  solvingTax: deSolvingTax,
  expertiseSolutions: deExpertiseSolutions,
  bghUrteile: deBghUrteile,
  faqs: deFaqs,
  calculator: deCalculator,
  judgmentsLanding: deJudgmentsLanding,
} as const;
